export default __webpack_public_path__ + "static/media/apple_podcast.acc3e4e4.svg";